import { inject, Injectable } from '@angular/core';

import { EMPTY, Observable } from 'rxjs';

import { ToastService } from '@app/core/ui/components/toast';

import { BemobiCheckoutService } from './bemobi-checkout.service';
import { EskolareCheckoutService } from './eskolare-checkout.service';
import { CheckoutStrategyEnum } from '../../models/checkout-strategy.enum';
import { CheckoutExecuteParams } from '../../models/shop-checkout-response.model';

@Injectable()
export class CheckoutOrchestratorService {
  private readonly eskolareCheckout = inject(EskolareCheckoutService);
  private readonly bemobiCheckout = inject(BemobiCheckoutService);
  private readonly toastService = inject(ToastService);

  execute({ response }: CheckoutExecuteParams): Observable<void> {
    if (response.checkoutStrategy === CheckoutStrategyEnum.Eskolare) {
      if (!EskolareCheckoutService.isValidResponse(response)) {
        this.toastService.danger(
          'Não foi possivel gerar link de pagamento. Tente novamente'
        );
        return EMPTY;
      }

      return this.eskolareCheckout.execute(response);
    }

    if (!BemobiCheckoutService.isValidStrategy(response)) {
      this.toastService.danger(
        'Não foi possivel iniciar checkout. Tente novamente'
      );
      return EMPTY;
    }

    return this.bemobiCheckout.execute(response);
  }
}
